"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleFromDriver = exports.vehicleDeserialize = void 0;
const ValidationResult_1 = require("../type-descriptions/ValidationResult");
const expect_1 = __importDefault(require("../util/expect"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const TransportType_1 = require("./TransportType");
function vehicleDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        color: (0, deserializeString_1.deserializeString)(object.color),
        driverId: (0, deserializeString_1.deserializeString)(object.driverId),
        licensePlateNumber: (0, deserializeString_1.deserializeString)(object.licensePlateNumber),
        make: (0, deserializeString_1.deserializeString)(object.make),
        model: (0, deserializeString_1.deserializeString)(object.model),
        transportType: (0, unwrap_1.default)(object.transportType, value => (0, ValidationResult_1.validationResultCheck)(TransportType_1.transportTypeDescription.validate(value))),
        trimId: (0, unwrap_1.default)(object.trimId, deserializeString_1.deserializeString),
        year: (0, deserializeNumber_1.deserializeNumber)(object.year),
    };
}
exports.vehicleDeserialize = vehicleDeserialize;
function vehicleFromDriver(driver) {
    return {
        id: driver.activeVehicleId,
        color: (0, expect_1.default)(driver.carColor),
        driverId: (0, expect_1.default)(driver.id),
        licensePlateNumber: (0, expect_1.default)(driver.licensePlateNumber),
        make: (0, expect_1.default)(driver.make),
        model: (0, expect_1.default)(driver.model),
        transportType: driver.transportType,
        trimId: driver.trimId,
        year: (0, expect_1.default)(driver.year),
    };
}
exports.vehicleFromDriver = vehicleFromDriver;
